<script lang="ts">
  import { CtaEntity, DistributorEntity } from "@shared/services/event_tracking/entities";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import type { Distributor } from "@shared/types/Distributor";

  export let distributor: Distributor;

  const trackingParams = [
    new CtaEntity({ service: "action_bar_distributor_link" }),
    DistributorEntity.fromDistributor(distributor),
  ];
</script>

<TrackingContext entities={trackingParams}>
  <slot />
</TrackingContext>
